export function clearSessionDevOverrides(overrides = {}) {
    const tenantOverride = overrides.tenantOverride || null;

    return {
        active: tenantOverride ? !!overrides.active : false,
        roleOverride: null,
        flagOverrides: {},
        planPreviewID: null,
        panelOpen: false,
        tenantOverride
    };
}
